<template>
  <v-menu
    offset-y
    transition="scale-transition"
    v-model="menu"
    :disabled="_readonly"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        ref="field"
        hide-details="auto"
        outlined
        dense
        v-model="search"
        :items="_items"
        v-on="{ ...on, ...$listeners }"
        v-bind="{ ...attrs, ...$attrs }"
        @input="v => isOnlySearch && fetchItems(v)"
        @blur="onBlur"
        :readonly="_readonly"
      >
        <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />
      </v-text-field>
      <form
        v-if="itemKey == 'language'"
        method="post"
        target="ybmPopup"
        action="https://ipexam.ybmnet.co.kr/comScore/ybm_step1.asp"
        ref="YBMForm"
        name="ybmFrm"
      >
        <input hidden name="CID" :value="cid" />
        <input hidden name="EXAMCODE" :value="examCd" />
        <input hidden name="RETURL" :value="returl" />
        <input hidden name="ETC" :value="domain" />
        <input hidden name="MODE" :value="mode" />
        <input hidden name="YBMRESULT_LEVEL" value="" />
        <input hidden name="YBMRESULT_DATE" value="" />
        <input hidden name="YBMRESULT_EXAMNO" value="" />
        <input hidden name="YBMRESULT_ORG" value="" />
      </form>

      <form
        v-if="itemKey == 'language'"
        method="post"
        target="opicPopup"
        action="https://opic.or.kr/opics/jsp/verify/opic_verify_start.jsp"
        ref="OPICForm"
        name="opicFrm"
      >
        <input hidden name="p_comp" id="p_comp" :value="p_comp" />
        <input hidden name="p_rtnurl" id="p_rtnurl" :value="p_rtnurl" />
        <input hidden name="OPIC_EXAMID" value="" />
        <input hidden name="OPIC_EXAMDATE" value="" />
        <input hidden name="OPIC_LANGUAGE" value="" />
        <input hidden name="OPIC_LEVEL" value="" />
        <input hidden name="OPIC_SUBJ" value="" />
      </form>

      <BasePopup
        v-if="canDirect"
        width="450px"
        v-model="popup"
        title="직접입력"
        :confirmCallback="onDirect"
      >
        <v-form ref="directForm" lazy-validation>
          <div>
            <v-text-field
              v-if="popup"
              hide-details
              :label="directLabel"
              dense
              outlined
              :rules="[required]"
              autofocus
              v-model="direct.name"
            />
            <template v-if="itemKey == 'school'">
              <v-text-field
                class="mt-4"
                hide-details
                label="소재지"
                dense
                :rules="collectionType !== 'high' ? [required] : []"
                outlined
                v-model="direct.region"
              />
              <v-text-field
                class="mt-4"
                hide-details
                :rules="collectionType !== 'high' ? [required] : []"
                label="캠퍼스"
                dense
                outlined
                v-model="direct.campusName"
              />
            </template>
          </div>
        </v-form>
      </BasePopup>
    </template>
    <v-list
      style="max-height:300px;overflow-y:auto;font-size:0.8rem;"
      class="pt-0"
    >
      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
      ></v-progress-linear>
      <v-list-item
        v-if="canDirect && !loading && !_items.length"
        class="cursor mt-2"
      >
        <span
          class="py-1 mx-auto direct-btn"
          style="width:100%;border-radius:14px"
          @click.stop="openPopup"
        >
          직접입력
        </span>
      </v-list-item>
      <v-list-item v-if="!_items.length">
        {{
          loading
            ? '검색중'
            : search
            ? '검색결과가 없습니다.'
            : '검색어를 입력하세요'
        }}
      </v-list-item>
      <!-- onClick 사용하게되면 blur 가 먼저 event를 발생하게 됨  -->
      <v-list-item
        v-else
        v-for="(item, i) in _items"
        :key="i"
        class="auto-list-item cursor"
        @click="onInput(item, i)"
        @mousedown="onInput(item, i)"
      >
        {{ item }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { API } from '@/api/network';
import { debounce } from '@/utils/util';
import BasePopup from './BasePopup.vue';

let searchIndex = 0;

const url = {
  language: '/cv/languages',
  license: '/cv/licenses',
  school: '/cv/schools',
  major: '/cv/school/majors',
  class: '/cv/school/majors/class',
};

export default {
  components: { BasePopup },
  props: {
    directInput: {
      type: [String, Boolean],
      default: false,
    },
    itemKey: {
      type: String,
      required: true,
    },
    collectionType: {
      type: String,
      default: 'normal',
    },
    value: {
      type: String,
    },
    readonly: {
      type: Boolean,
    },
    campusShow: {
      type: Boolean,

      default: false,
    },
    debounceDelay: {
      type: Number,
      default: 250,
    },
    languageCertYn: {
      type: String,
      default: 'N',
    },
  },
  data() {
    return {
      popup: false,
      direct: {
        name: '',
        region: '',
        campusName: '',
      },
      menu: false,
      items: [],
      loading: false,
      selected: '',
      examCd: '1',
      cid: '',
      returl: '',
      mode: '',
      domain: window.location.origin,
      p_comp: '',
      p_rtnurl: '',
    };
  },
  watch: {
    search(v) {
      if (v && v != this.selected) {
        this.fetchItems(v);
        this.menu = true;
      }
    },
  },
  inject: {
    form: {
      default: null,
    },
  },
  mounted() {
    this.selected = this.search;
    this.form?.register?.(this.$refs.field);
  },
  computed: {
    directLabel() {
      return this.$attrs.label?.replace('*', '');
    },
    nameKey() {
      return this.itemKey === 'school'
        ? 'schoolName'
        : this.itemKey === 'class'
        ? 'class'
        : 'name';
    },
    _readonly() {
      return this.readonly ?? this.form?.readonly ?? false;
    },
    search: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
    canDirect() {
      return this.directInput === 'Y' || this.directInput === true;
    },
    _items() {
      return this.items.map(v => this.parser(v)).filter(v => v);
    },
    isOnlySearch() {
      // v-model 없이 검색 용도 인 경우
      return !this.$listeners.input;
    },
  },
  methods: {
    async onBlur() {
      await this.$nextTick();
      if (this.selected.replace(/\s+/g, '') != this.value.replace(/\s+/g, '')) {
        this.selected = '';
        this.$emit('input', !this.value ? '' : this.selected);
      }
      this.items = [];
    },
    parser(item) {
      if (this.itemKey == 'school' && this.campusShow) {
        const parts = [];
        if (item.campusName) parts.push(`[${item.campusName}]`);
        if (item.region) parts.push(`[${item.region}]`);
        return parts.length
          ? `${item.schoolName} ${parts.join(' ')}`
          : item.schoolName;
      }
      if (this.itemKey == 'school' && this.collectionType === 'high') {
        return `${item.schoolName} [${item.region}]`;
      }

      return item[this.nameKey];
    },
    async onInput(keyword, index) {
      this.selected = keyword;
      this.search = keyword;
      if (this.isOnlySearch) this.$refs.field.reset();
      await this.$emit('change:item', this.items[index]);
      //언어입력란이고 유효성검사 안맞는 경우는 YBM팝업을 열지 않음
      if (
        this.itemKey == 'language' &&
        this.$refs.field.valid &&
        this.languageCertYn == 'Y'
      ) {
        if (keyword == 'TOEIC') {
          this.examCd = '1';
          this.openYBMpopup();
        } else if (keyword == 'TOEIC Speaking (new)') {
          this.examCd = '5';
          this.openYBMpopup();
        } else if (keyword == 'TOEIC Speaking') {
          this.examCd = '5';
          this.openYBMpopup();
        } else if (keyword == 'TOEIC Writing') {
          this.examCd = '10';
          this.openYBMpopup();
        } else if (keyword == 'JPT') {
          this.examCd = '2';
          this.openYBMpopup();
        } else if (keyword == 'TSC') {
          this.examCd = '7';
          this.openYBMpopup();
        } else if (keyword == 'SJPT') {
          this.examCd = '8';
          this.openYBMpopup();
        } else if (keyword.includes('OPIc')) {
          this.openOpicPopup();
        }
      }
    },
    fetchItems(searchWord) {
      const index = ++searchIndex;
      if (!url[this.itemKey] || !searchWord || this.readonly) return;
      this.loading = true;
      debounce(
        async () => {
          try {
            const { data } = await API.postAuthJson(url[this.itemKey], {
              searchWord,
              type: this.collectionType,
              rows: 20,
            });
            // 검색된 items 가 많을수록 오래 걸리기때문에 순서 보장을 위한 index
            if (index == searchIndex) this.items = data.data || [];
          } catch (error) {
            this.items = [];
            console.error(error);
          } finally {
            this.loading = false;
          }
        },
        `autoComplete${this.itemKey}`,
        this.debounceDelay,
      );
    },
    openPopup() {
      Object.assign(this, {
        menu: false,
        direct: {
          name: '',
          region: '',
          campusName: '',
        },
      });
      this.$refs.directForm?.reset();
      this.popup = true;
    },
    onDirect(closePopup) {
      if (!this.$refs.directForm.validate()) return;
      closePopup();
      const name =
        this.direct.name +
        (this.itemKey == 'school' && this.direct.campusName
          ? `[${this.direct.campusName}]`
          : '');
      this.selected = name;
      this.search = name;
      const item = {
        ...this.direct,
        [this.nameKey]: this.direct.name,
        directYn: 'Y',
        itemKey: this.itemKey,
      };
      this.$emit('change:item', item);
    },
    required(v) {
      return !!v.replaceAll(' ', '') || '필수 입력 항목';
    },
    async openYBMpopup() {
      /* YBM 파라미터 암호화 */
      await API.postAuthJson('/cv/languages/encrypt', {})
        .then(res => {
          this.cid = res.data.cid;
          this.returl = res.data.returl;
          this.mode = res.data.mode;
        })
        .catch(error => {
          console.log(error);
        });

      window.open('', 'ybmPopup', 'width=820,height=560');
      setTimeout(() => {
        this.$refs.YBMForm.submit();
      }, 500);
    },

    async openOpicPopup() {
      const domain = this.domain;
      /* OPIC 파라미터 암호화 */
      await API.postAuthJson('/cv/languagesOpic/encrypt', domain)
        .then(res => {
          this.p_comp = res.data.p_comp;
          this.p_rtnurl = res.data.p_rtnurl;
        })
        .catch(error => {
          console.log(error);
        });

      window.open('', 'opicPopup', 'width=820,height=560');
      setTimeout(() => {
        this.$refs.OPICForm.submit();
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.auto-list-item {
  &:hover {
    background-color: rgba($color: #363c43, $alpha: 0.1);
  }
}
::v-deep {
  .v-list .v-list-item {
    min-height: 34px !important;
  }
}
.direct-btn {
  transition: background-color 0.1s;
  background-color: #eee;
  text-align: center;
  &:hover {
    background-color: rgba($color: #363c43, $alpha: 0.2);
  }
}
</style>
